export function SectionHeader({ eyebrow, title, sub, align = "left", testid }) {
  return (
    <div className={`mb-10 sm:mb-14 ${align === "center" ? "text-center" : ""}`} data-testid={testid}>
      {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white leading-[0.95]">
        {title}
      </h2>
      {sub && (
        <p className={`mt-4 max-w-2xl text-sm sm:text-base leading-relaxed text-slate-400 ${align === "center" ? "mx-auto" : ""}`}>
          {sub}
        </p>
      )}
    </div>
  );
}

export default SectionHeader;
